var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-select-dropdown",class:_vm.className,style:(_vm.styles)},[(_vm.vueScrollEnable)?_c('div',{staticClass:"vue-scroll-outer",style:({
            height: _vm.dropHeight,
            overflow: 'auto',
            maxHeight: '186px'
        })},[_c('vue-scroll',{attrs:{"ops":_vm.vueScrollOpts},on:{"handle-scroll":function (v) { return _vm.$emit('handle-scroll', v); }}},[_vm._t("default")],2)],1):_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/select/dropdown.vue